import React from "react";
import "../assets/css/MarqueeSection.css";

const MarqueeSection = () => {
  return (
    <section className="marquee-section py-2 mt-2">
      <div className="container-fluid">
        <div className="marquee">
          <div className="marquee__content">
            <span>From skincare and haircare to medical engineering, every solution is rooted in molecular science |</span>
            <span>From skincare and haircare to medical engineering, every solution is rooted in molecular science |</span>
            <span>From skincare and haircare to medical engineering, every solution is rooted in molecular science |</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MarqueeSection;
